import { render, staticRenderFns } from "./saolei.vue?vue&type=template&id=390e2ac6&scoped=true"
import script from "./saolei.vue?vue&type=script&lang=js"
export * from "./saolei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390e2ac6",
  null
  
)

export default component.exports